<template>
  <div>
        <flexbox class="p-2">
      <flexbox-item >
        <b-button variant="success" class="py-2 mt-4" block @click="setAddress">{{$t('cart.address.save')}}</b-button>
      </flexbox-item>
    </flexbox>
    <group :title="$t('cart.address.address')" label-width="4.5em" label-margin-right="2em">
      <x-input :title="$t('cart.address.name')" v-model="address.name"></x-input>
    </group>
    <div style="color: red; padding-left: 15px; padding-top:10px">{{$t('cart.address.notice')}}</div>
    <group>
      <selector  :title="$t('cart.address.region')" :options="['+86','+852','+853']" v-model="address.region"></selector>
      <x-input :title="$t('cart.address.mobile')" type="number" v-model="address.mobile" required></x-input>
      <selector  :title="$t('kol.region.region')" :options="addressOptions" v-model="address.country"></selector>
      <x-address v-if="address.region=='cn'" :title="$t('cart.address.address')" raw-value :list="addressData" value-text-align="left" label-align="justify" v-model="address.addressValues" :cancel-text="$t('kol.header.cancel')" :confirm-text="$t('kol.header.confirm')"></x-address>
      <x-textarea :title="$t('cart.address.detail')" v-model="address.detail" :placeholder="$t('cart.address.inputDetail')" :show-counter="false" :rows="2"></x-textarea>
    </group>


  </div>
</template>
<script type="text/javascript">

import { GroupTitle, Group, Cell, XInput, Selector, PopupPicker, Datetime, XNumber, ChinaAddressData, XAddress, XTextarea, XSwitch,
Flexbox, FlexboxItem, Value2nameFilter as value2name } from 'vux'
import Cookies from 'js-cookie'

export default {
  name: 'AddressCreate',
  components: {
    Group,
      GroupTitle,
      Cell,
      XInput,
      Selector,
      PopupPicker,
      XAddress,
      Datetime,
      XNumber,
      XTextarea,
      XSwitch,
      Flexbox, 
      FlexboxItem
  },
  props: {
    addressInput: {
      type: Object,
      default: function () {
        return { addressValues: []}
      }
    },
    edit: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      address: this.addressInput,
      addressData: ChinaAddressData,
      addressOptions: [{
        value: this.$t('kol.region.cn'),
        type:'default',
        key:'cn'
      },{
        value: this.$t('kol.region.hk'),
        type:'default',
        key:'hk'
      },{
        value: this.$t('kol.region.mo'),
        type:'default',
        key:'mo'
      },
      ],
    }
  },
  created() {
    document.title = this.$t('cart.address.create');
    this.$store.commit("hideFooter", false);
    if(this.edit){
      this.address.addressValues = [this.address.province, this.address.city, this.address.district]; 
    }
  },
  mounted() {},
  watch: {
    'address.addressValues':{
      handler(newVal, oldVal) {
        var nameStr = value2name(this.address.addressValues, ChinaAddressData);
        var names = nameStr.split(" ");

        this.address.province = names[0];
        this.address.city = names[1];
        this.address.district = names[2];
      },
      deep: true
    }
  },
  computed: {
    getLocale(){
      return Cookies.get('locale');
    }

  },
  methods: {
    setAddress(){

      if(this.edit == true){
        this.editUserAddress();
      }else{
        this.createUserAddress();
      }

    },
    createUserAddress(){
        this.$store.dispatch('Cart/createUserAddress', this.address).then((json) => {
  
          if(json.status == 401){
            Cookies.remove('token');
            this.$router.push('/login');
          }else{
            this.$router.go(-1);
            this.$store.commit("forceRefresh",true)
          }
        }).catch((err) => {
          console.error(err);
        });
    },

    editUserAddress(){
      this.$store.dispatch('Cart/editUserAddress', this.address).then((json) => {

        if(json.status == 401){
          Cookies.remove('token');
          this.$router.push('/login');
        }else{
          this.$router.go(-1);
          this.$store.commit("forceRefresh",true)
        }
      }).catch((err) => {
        console.error(err);
      });
    },

  },
}

</script>
<style type="text/css">
.headerContainer{
/*  margin-top: 44px;
*/}
</style>




// WEBPACK FOOTER //
// src/Cart/containers/AddressCreate.vue